import React from 'react';
import * as PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import ReplayOutlinedIcon from '@material-ui/icons/Refresh';
import { SubjectPropType } from '../../abilities/proptypes';
import { UPDATE } from '../../abilities/actions';
import IconButton from './IconButton';

const RefreshIconButton = ({ onClick, size, disabled, subject, title }) => (
    <IconButton onClick={onClick} size={size} disabled={disabled} subject={subject} action={UPDATE}>
        {title ? (
            <Tooltip title={title}>
                <ReplayOutlinedIcon />
            </Tooltip>
        ) : (
            <ReplayOutlinedIcon />
        )}
    </IconButton>
);

RefreshIconButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    size: PropTypes.string,
    disabled: PropTypes.bool,
    subject: SubjectPropType,
    title: PropTypes.string,
};

RefreshIconButton.defaultProps = {
    size: null,
    disabled: false,
    subject: null,
    title: null,
};

export default RefreshIconButton;
